import type { FC } from 'react';
import { Modal } from '@interstate/components/Modal';
import { Typography } from '@interstate/components/Typography';

interface DeskingFnISwitchErrorsModalProps {
    show: boolean;
    onClose: () => void;
    onContinue: () => void;
}

const TITLE = 'Warning';
const MESSAGE = 'This deal contains missing data or errors. If you proceed, these issues will be carried over to F&I Mode.';

export const DeskingFnISwitchErrorsModal: FC<DeskingFnISwitchErrorsModalProps> = ({ show, onClose, onContinue }) => {
    return (
        <Modal
            size="small"
            id="desking-fni-switch-errors-modal"
            data-testid="desking-fni-switch-errors-modal"
            show={show}
            onHide={onClose}
            header={
                <Typography variant="h4" color="base.color.blue.700">
                    {TITLE}
                </Typography>
            }
            footer={{
                layout: 'rightAligned',
                options: {
                    action: onClose,
                    label: 'Review Errors',
                    buttonStyle: 'tertiary',
                    customIdentifiers: {
                        optionButton0: {
                            dataTestId: 'desking-fni-switch-errors-review-btn'
                        }
                    }
                },
                primary: {
                    action: onContinue,
                    label: 'Continue to F&I Mode',
                    customIdentifiers: {
                        primaryButton: {
                            dataTestId: 'desking-fni-switch-errors-continue-btn'
                        }
                    }
                }
            }}
        >
            <Typography variant="body-md" tag="span">
                {MESSAGE}
            </Typography>
        </Modal>
    );
};
